export { default } from './components/select';
